/**
 * useCamera — license disk silhouette SVG
 *
 * Rendered as a semi-transparent white outline inside the scanning frame
 * to help the user position the license disk correctly. Shows a circle
 * representing the disk itself, with a rectangular area indicating where
 * the PDF417 barcode is located on the disk.
 *
 * South African license disks are small paper discs displayed on the
 * windshield. They have a circular shape with vehicle details printed
 * around the edge and a PDF417 barcode in the center-bottom area.
 */

import React from 'react';

export function LicenseDiskSilhouette() {
  return (
    <svg viewBox="0 0 200 200" className="w-full h-full" fill="none" stroke="currentColor" strokeWidth={1.5}>
      {/* Outer circle — the disk itself */}
      <circle cx={100} cy={100} r={85} opacity={0.5} />
      {/* Inner circle — printed content boundary */}
      <circle cx={100} cy={100} r={72} opacity={0.3} strokeDasharray="4 4" />
      {/* PDF417 barcode rectangle — center-bottom of disk */}
      <rect x={55} y={95} width={90} height={38} rx={3} opacity={0.7} strokeWidth={2} />
      {/* Barcode lines inside the rectangle */}
      {Array.from({ length: 15 }).map((_, i) => (
        <line
          key={i}
          x1={60 + i * 5.5}
          y1={100}
          x2={60 + i * 5.5}
          y2={128}
          opacity={0.4}
          strokeWidth={i % 3 === 0 ? 1.5 : 0.8}
        />
      ))}
      {/* Text lines around the top of the disk (registration, make, etc.) */}
      <line x1={65} y1={45} x2={135} y2={45} opacity={0.3} strokeWidth={0.8} />
      <line x1={60} y1={55} x2={140} y2={55} opacity={0.3} strokeWidth={0.8} />
      <line x1={65} y1={65} x2={135} y2={65} opacity={0.3} strokeWidth={0.8} />
      {/* Expiry date line at bottom */}
      <line x1={75} y1={150} x2={125} y2={150} opacity={0.3} strokeWidth={0.8} />
      {/* Small circle at top center — disk perforation/marker */}
      <circle cx={100} cy={30} r={3} opacity={0.4} />
    </svg>
  );
}

export default LicenseDiskSilhouette;
